<template>
     <CardUploadFiles
        :isVisiblePrimary="false"
        :titleCard="'Precisamos verificar sua CNH'"
        :cardDescription="'cnh'"
        :textCard="'CNH'"
        :textCardAttention="'O documento precisa estar no nome do titular'"
        :isVisibleTextList="true"
        :srcExampleImage="IconDocument"
        :nextRoute="'UploadSelfieCnh'"
        :previewScreen="'PreviewDocumentationFiles'"
    />
</template>
<script>
import CardUploadFiles from '../../components/CardUploadFiles.vue'
import FooterButton from '../../components/FooterButton.vue';
import IconDocument from '../../../../public/images/illustration-document.svg'

export default {
components: {
    CardUploadFiles,
    FooterButton
},
setup() {
    return {
        IconDocument
    };
  },
}
</script>